// /home/vitruvio/puntum-frontend/src/components/Gatekeeper.jsx

import React from 'react';
import { useAuth } from '../context/AuthContext';

export default function Gatekeeper({ children, onNavigate }) {
  const { user } = useAuth();

  // Determinar si la empresa necesita completar sus datos obligatorios
  const needsCompanyUpdate = user?.needs_company_update ?? true;

  if (needsCompanyUpdate) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '80vh',
        padding: '2rem'
      }}>
        <div style={{
          backgroundColor: '#ffffff',
          borderRadius: '1rem',
          border: '1px solid #e2e8f0',
          boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.05), 0 8px 10px -6px rgba(0, 0, 0, 0.01)',
          maxWidth: '520px',
          width: '100%',
          padding: '2.5rem',
          textAlign: 'center'
        }}>
          {/* Ícono de Alerta / Candado */}
          <div style={{
            width: '64px',
            height: '64px',
            borderRadius: '50%',
            backgroundColor: '#fef3c7',
            color: '#d97706',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '2rem',
            margin: '0 auto 1.5rem auto',
            border: '2px solid #fde68a'
          }}>
            🔒
          </div>

          <h2 style={{
            fontSize: '1.35rem',
            fontWeight: '700',
            color: '#0f172a',
            margin: '0 0 0.75rem 0'
          }}>
            Configuración Inicial Requerida
          </h2>

          <p style={{
            fontSize: '0.9rem',
            color: '#64748b',
            lineHeight: '1.5',
            margin: '0 0 1.75rem 0'
          }}>
            Para comenzar a gestionar tu inventario y realizar ventas, primero debes completar la información legal y tributaria en <strong>Mi Empresa</strong>. Esto activará tu <strong>Casa Matriz</strong> y garantizará que tus comprobantes sean válidos.
          </p>

          {/* Tarjeta de Beneficios Tácticos */}
          <div style={{
            backgroundColor: '#f8fafc',
            borderRadius: '0.5rem',
            border: '1px solid #e2e8f0',
            padding: '1rem',
            textAlign: 'left',
            marginBottom: '1.75rem',
            fontSize: '0.825rem',
            color: '#334155'
          }}>
            <div style={{ fontWeight: '600', marginBottom: '0.5rem', color: '#1e293b' }}>
              Al completar la ficha obtenerás:
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.35rem' }}>
              <span>✅</span> Emisión de comprobantes con RUT y Giro comercial.
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.35rem' }}>
              <span>✅</span> Activación inmediata de tu primera sucursal (Casa Matriz).
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <span>✅</span> Desbloqueo total del módulo de Ventas e Inventario.
            </div>
          </div>

          {/* Botón de Redirección */}
          <button
            onClick={() => {
              if (onNavigate) onNavigate('configuracion');
            }}
            style={{
              width: '100%',
              backgroundColor: '#2563eb',
              color: '#ffffff',
              padding: '0.85rem',
              borderRadius: '0.5rem',
              fontWeight: '600',
              fontSize: '0.95rem',
              border: 'none',
              cursor: 'pointer',
              boxShadow: '0 4px 6px -1px rgba(37, 99, 235, 0.2)',
              transition: 'all 0.2s ease'
            }}
          >
            ⚙️ Ir a Configuración de Mi Empresa
          </button>
        </div>
      </div>
    );
  }

  // Si la empresa ya completó sus datos, permite el libre acceso al módulo
  return children;
}